import Periscope from './components/Periscope'
import Burger from './components/Burger'
import NeighborhoodMap from './components/NeighborhoodMap'
import NeighborhoodPicker from './components/NeighborhoodPicker'
import ThingsToDo from './components/ThingsToDo'
import ThingsToDoFilters from './components/ThingsToDoFilters'
import ImageSlideshow from './components/ImageSlideshow'
import ImageCarousel from './components/ImageCarousel'
import ApartmentMatchmaker from './components/ApartmentMatchmaker'
import ViewProps from './components/ViewProps'
import Entrance from './components/Entrance'
import HashScroll from './components/HashScroll'
import Properties from './components/Properties'
document.addEventListener('DOMContentLoaded', () => {
    Periscope.init()
    HashScroll.init()
    Burger.init()
    NeighborhoodMap.init()
    NeighborhoodPicker.init()
    ThingsToDo.init()
    ThingsToDoFilters.init()
    ImageSlideshow.init()
    ImageCarousel.init()
    ApartmentMatchmaker.init()
    ViewProps.init()
    Entrance.init()
    Properties.init()
})
